export enum StateSliceStatus {
  Uninitialized = 'Uninitialized',
  Initialized = 'Initialized',
  Loading = 'Loading',
  Error = 'Error',
}
